export function scrollAfterRotation() {
	let scrollPosition = 0;

	// Store scroll position before the orientation change
	function storeScrollPosition(){
		scrollPosition = window.offsetHeight || document.documentElement.scrollTop;
	}

	// Restore scroll position after the orientation change
	function restoreScrollPosition(){
		window.scrollTo(0, scrollPosition);
	}

	// Attach event listeners
	window.addEventListener("orientationchange", ()=> {
		storeScrollPosition();

		// Timeout is necessary because the orientationchange event fires before
		// the browser completes the rotation and re-renders the layout
		setTimeout(restoreScrollPosition, 100);
	});
}
